/* True Machines PDP v2 — vanilla JS.
   Behaviors transcribed from the reference build (see reference/README.md M1–M6).
   State grows per section: theme toggle (header) → hero carousel → accordion → water map. */
(function () {
  'use strict';

  /* Dark mode removed 2026-07-13 (Utkarsh) — the [data-tm-theme="dark"] token block stays
     dormant in tm-design-system.css; nothing sets the attribute anymore. */

  /* ---------- deep-link scroll (M3 offset rule) ----------
     Never scrollIntoView; compute offset and window.scrollTo (README Interactions). */
  window.TM = window.TM || {};
  window.TM.goTo = function (elemId, key) {
    if (key && typeof window.TM.openCheck === 'function') {
      window.TM.openCheck(key); // set true, never toggle-closed (M3)
    }
    setTimeout(function () {
      var el = document.getElementById(elemId);
      if (el) {
        var top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }, 80);
  };

  /* ---------- hero carousel (M1 + M2) ----------
     One source of truth: heroIndex. Every entry point mutates only it. */
  function initHero() {
    var root = document.querySelector('[data-tm-gallery]');
    if (!root) return;
    var track = root.querySelector('[data-tm-track]');
    var viewport = root.querySelector('[data-tm-viewport]');
    var strip = root.querySelector('[data-tm-thumbs]');
    var swipeHint = viewport ? viewport.querySelector('.tm-swipe-hint') : null;
    var swipeLearned = false;
    var thumbs = strip ? Array.prototype.slice.call(strip.children) : [];
    var n = thumbs.length;
    var heroIndex = 0;
    var escalated = false;
    var escTimer = null;

    /* Perf: only the hero (slot 0) main image is loading="eager"; slots 1..n-1 ship
       loading="lazy" so they stay OFF the initial critical path (~700KB saved on mobile).
       BUT native lazy never fires here — the track is transform-translated inside an
       overflow:hidden viewport, so off-screen slides are clipped, not scrolled, and the
       browser's intersection check never sees them. So we hand them over on demand:
       flipping a still-lazy, not-yet-loaded <img> to loading="eager" starts its fetch
       immediately (HTML spec). ensureLoaded(clamped) covers the slide you land on;
       we also prefetch the next slide once the user has moved past the hero, so the
       initial paint stays hero-only but subsequent swipes feel instant. */
    var galImgs = track ? Array.prototype.slice.call(track.querySelectorAll('.tm-gal-img')) : [];
    function ensureLoaded(i) {
      var im = galImgs[i];
      if (im && im.getAttribute('loading') === 'lazy') im.loading = 'eager';
    }

    function scrollThumbs(index) {
      var target = strip.children[Math.max(0, index - 1)];
      if (target) strip.scrollLeft = target.offsetLeft; // direct assign — smooth scrollTo is cancelled by scroll-snap (M2.3)
    }

    function setHero(i) {
      var clamped = Math.max(0, Math.min(n - 1, i));
      /* tm_gallery_view — fires only on an ACTUAL change, which also makes the initial setHero(0)
         and clamped no-ops (prev at 0, next at the end) silent. One event for every entry point
         (thumb, arrows, mouse drag, touch swipe) since they all funnel through here. */
      if (clamped !== heroIndex && typeof window.tmTrack === 'function') {
        window.tmTrack('tm_gallery_view', {
          sku: (window.TM_ANALYTICS && window.TM_ANALYTICS.product && window.TM_ANALYTICS.product.sku) || '',
          index: clamped
        });
      }
      heroIndex = clamped;
      ensureLoaded(clamped);                     // load the slide now in view (lazy → eager)
      if (clamped > 0) ensureLoaded(clamped + 1); // prefetch the next; keeps initial paint hero-only
      track.style.transform = 'translateX(' + (-clamped * 100) + '%)';
      /* the "swipe ›" cue signals the gallery is swipeable (arrows are hidden on mobile);
         show it only on the first shot and retire it once the user has swiped once */
      if (clamped > 0) swipeLearned = true;
      if (swipeHint) swipeHint.style.visibility = (clamped === 0 && !swipeLearned) ? '' : 'hidden';
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-sel', idx === clamped);
      });
      if (clamped >= 2 && !escalated && !escTimer) {
        escTimer = setTimeout(function () {
          escalated = true; // one-way; timer never re-arms (M1)
          root.classList.add('is-esc');
        }, 1000);
      }
      requestAnimationFrame(function () { scrollThumbs(clamped); });
      setTimeout(function () { scrollThumbs(clamped); }, 60);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setHero(i); });
    });
    var prev = root.querySelector('[data-tm-prev]');
    var next = root.querySelector('[data-tm-next]');
    if (prev) prev.addEventListener('click', function () { setHero(heroIndex - 1); });
    if (next) next.addEventListener('click', function () { setHero(heroIndex + 1); });

    root.querySelectorAll('[data-tm-chip]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.stopPropagation(); // don't count as a swipe (M1)
        e.preventDefault();
        var anchor = chip.getAttribute('data-tm-chip');
        var key = anchor.indexOf('check-') === 0 ? 'c' + anchor.slice(6) : null;
        window.TM.goTo(anchor, key);
      });
    });

    /* swipe/drag — 30px threshold; touch claims the gesture only on
       clear horizontal intent (|dx| > |dy|, gotcha #11) */
    var down = false, msx = 0, mlx = 0, msy = 0, mly = 0, downTarget = null;
    viewport.addEventListener('mousedown', function (e) {
      down = true; msx = mlx = e.clientX; msy = mly = e.clientY; downTarget = e.target; e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) { if (down) { mlx = e.clientX; mly = e.clientY; } });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      var dx = mlx - msx, dy = mly - msy;
      if (Math.abs(dx) < 30) {
        /* a click (not a drag) on the image opens the fullscreen viewer — buttons excluded */
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8 && downTarget && !downTarget.closest('button')) {
          openLightbox(heroIndex);
        }
        return;
      }
      setHero(heroIndex + (dx < 0 ? 1 : -1));
    });
    var sx = null, sy = null, lx = null, ly = null, tStartTarget = null;
    viewport.addEventListener('touchstart', function (e) {
      sx = lx = e.touches[0].clientX;
      sy = ly = e.touches[0].clientY;
      tStartTarget = e.target;
    }, { passive: true });
    viewport.addEventListener('touchmove', function (e) {
      if (sx != null) { lx = e.touches[0].clientX; ly = e.touches[0].clientY; }
    }, { passive: true });
    function endTouch() {
      if (sx == null) return;
      var dx = lx - sx, dy = ly - sy, tgt = tStartTarget;
      sx = sy = lx = ly = null;
      /* a tap (negligible movement) on the image opens the fullscreen viewer — buttons excluded */
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10 && tgt && !tgt.closest('button')) {
        openLightbox(heroIndex);
        return;
      }
      if (Math.abs(dx) < 30 || Math.abs(dx) <= Math.abs(dy)) return;
      setHero(heroIndex + (dx < 0 ? 1 : -1));
    }
    viewport.addEventListener('touchend', endTouch);
    viewport.addEventListener('touchcancel', endTouch);

    /* ---------- fullscreen lightbox (M-mobile: tap-to-zoom) ----------
       Lets phone users actually read the dense info slides whose baked-in text was too
       small and partly covered by the (now hidden ≤920) prev/next arrows. Pinch or
       double-tap to zoom, drag to pan, swipe/‹›/arrow-keys to move between shots. */
    var lbSrcs = Array.prototype.slice.call(track.children).map(function (f) {
      var im = f.querySelector('.tm-gal-img');
      return im ? (im.currentSrc || im.src) : '';
    });
    var lbIndex = 0, scale = 1, tx = 0, ty = 0;

    var lb = document.createElement('div');
    lb.className = 'tm-lb';
    lb.setAttribute('hidden', '');
    lb.innerHTML =
      '<button type="button" class="tm-lb-close" data-lb-close aria-label="Close">✕</button>' +
      '<div class="tm-lb-stage" data-lb-stage><img class="tm-lb-img" alt="" data-lb-img></div>' +
      '<div class="tm-lb-nav">' +
        '<button type="button" data-lb-prev aria-label="Previous image">‹</button>' +
        '<span class="tm-lb-count" data-lb-count></span>' +
        '<button type="button" data-lb-next aria-label="Next image">›</button>' +
      '</div>';
    document.body.appendChild(lb);
    var lbStage = lb.querySelector('[data-lb-stage]');
    var lbImg = lb.querySelector('[data-lb-img]');
    var lbCount = lb.querySelector('[data-lb-count]');
    var lbPrev = lb.querySelector('[data-lb-prev]');
    var lbNext = lb.querySelector('[data-lb-next]');

    function lbApply() {
      lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }
    function lbClampPan() {
      var s = lbStage.getBoundingClientRect();
      var maxX = Math.max(0, (lbImg.clientWidth * scale - s.width) / 2);
      var maxY = Math.max(0, (lbImg.clientHeight * scale - s.height) / 2);
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    }
    function lbResetZoom() { scale = 1; tx = 0; ty = 0; lbApply(); }
    function lbRender() {
      lbImg.src = lbSrcs[lbIndex] || '';
      lbCount.textContent = (lbIndex + 1) + ' / ' + lbSrcs.length;
      lbPrev.disabled = lbIndex === 0;
      lbNext.disabled = lbIndex === lbSrcs.length - 1;
      lbResetZoom();
    }
    function lbGo(i) {
      var c = Math.max(0, Math.min(lbSrcs.length - 1, i));
      if (c === lbIndex) return;
      lbIndex = c;
      setHero(c); // keep the underlying gallery in sync
      lbRender();
    }
    function openLightbox(i) {
      lbIndex = Math.max(0, Math.min(lbSrcs.length - 1, i));
      lbRender();
      lb.removeAttribute('hidden');
      document.body.classList.add('tm-lb-open');
    }
    function closeLightbox() {
      lb.setAttribute('hidden', '');
      document.body.classList.remove('tm-lb-open');
      lbResetZoom();
    }
    lb.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', function () { lbGo(lbIndex - 1); });
    lbNext.addEventListener('click', function () { lbGo(lbIndex + 1); });
    document.addEventListener('keydown', function (e) {
      if (lb.hasAttribute('hidden')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') lbGo(lbIndex - 1);
      else if (e.key === 'ArrowRight') lbGo(lbIndex + 1);
    });

    var lbLastTap = 0, lbPan = false, lbPx = 0, lbPy = 0, lbBx = 0, lbBy = 0, lbMoved = false;
    var lbPinch = false, lbPinchStart = 0, lbPinchBase = 1;
    function lbDist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }

    lbStage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        lbPinch = true; lbPinchStart = lbDist(e.touches); lbPinchBase = scale; lbPan = false;
      } else if (e.touches.length === 1) {
        lbPan = true; lbMoved = false;
        lbPx = e.touches[0].clientX; lbPy = e.touches[0].clientY; lbBx = tx; lbBy = ty;
      }
    }, { passive: true });
    lbStage.addEventListener('touchmove', function (e) {
      if (lbPinch && e.touches.length === 2) {
        scale = Math.max(1, Math.min(4, lbPinchBase * (lbDist(e.touches) / (lbPinchStart || 1))));
        if (scale === 1) { tx = 0; ty = 0; }
        lbClampPan(); lbApply();
      } else if (lbPan && e.touches.length === 1 && scale > 1) {
        tx = lbBx + (e.touches[0].clientX - lbPx);
        ty = lbBy + (e.touches[0].clientY - lbPy);
        lbMoved = true; lbClampPan(); lbApply();
      } else if (lbPan && e.touches.length === 1) {
        if (Math.abs(e.touches[0].clientX - lbPx) > 8) lbMoved = true;
      }
    }, { passive: true });
    lbStage.addEventListener('touchend', function (e) {
      if (lbPinch && e.touches.length < 2) { lbPinch = false; if (scale < 1.02) lbResetZoom(); }
      if (lbPan && e.touches.length === 0) {
        lbPan = false;
        var dx = (e.changedTouches[0] ? e.changedTouches[0].clientX : lbPx) - lbPx;
        if (scale === 1) {
          if (Math.abs(dx) > 50) { lbGo(lbIndex + (dx < 0 ? 1 : -1)); return; }
          if (!lbMoved) {
            var now = Date.now();
            if (now - lbLastTap < 300) { scale = 2.4; lbApply(); lbLastTap = 0; }
            else { lbLastTap = now; }
          }
        }
      }
    });
    lbStage.addEventListener('dblclick', function () {
      if (scale === 1) { scale = 2.4; lbApply(); } else { lbResetZoom(); }
    });
    lbStage.addEventListener('click', function (e) {
      if (e.target === lbStage && scale === 1) closeLightbox();
    });

    setHero(0);
  }

  /* ---------- accordion (M3) ----------
     c1 open initially; toggles independent; rail/chip deep-links set open=true, never flip. */
  function initChecklist() {
    var checks = document.querySelectorAll('[data-tm-check]');
    if (!checks.length) return;

    /* tm_check_expand — fires on OPEN only (collapsing isn't engagement), and only when the state
       actually changes, so the rail/chip deep-links that force open an already-open check stay
       silent instead of inflating the count. */
    function setOpen(el, open) {
      var was = el.classList.contains('is-open');
      el.classList.toggle('is-open', open);
      var head = el.querySelector('.tm-check-headrow');
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && !was && typeof window.tmTrack === 'function') {
        window.tmTrack('tm_check_expand', {
          sku: (window.TM_ANALYTICS && window.TM_ANALYTICS.product && window.TM_ANALYTICS.product.sku) || '',
          check: el.getAttribute('data-tm-check') || ''
        });
      }
    }

    checks.forEach(function (el) {
      var head = el.querySelector('.tm-check-headrow');
      if (!head) return;
      function toggle() {
        setOpen(el, !el.classList.contains('is-open'));
      }
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });

    window.TM.openCheck = function (key) {
      var el = document.querySelector('[data-tm-check="' + key + '"]');
      if (el) setOpen(el, true); // set true, don't flip (M3)
    };

    document.querySelectorAll('[data-tm-jump]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var anchor = btn.getAttribute('data-tm-jump');
        window.TM.goTo(anchor, 'c' + anchor.slice(6));
      });
    });
  }

  /* ---------- water map (T16, gotcha #8) ----------
     Runtime fetch of the geojson; equirectangular projection w/ latitude correction;
     4 hardness bands; loading + text-fallback states. Transcribed from the reference. */
  function initWaterMap() {
    var fig = document.querySelector('[data-tm-water-map]');
    if (!fig) return;
    var loadingEl = fig.querySelector('.tm-map-loading');
    var failedEl = fig.querySelector('.tm-map-failed');
    var svgWrap = fig.querySelector('.tm-map-svgwrap');
    var legendEl = fig.querySelector('.tm-map-legend');

    var BANDS = [
      { label: 'Soft', fill: '#DDE1E6' },
      { label: 'Moderate', fill: '#E7C9BC' },
      { label: 'Hard', fill: '#D08A72' },
      { label: 'Very hard', fill: '#C0533B' }
    ];
    var HARDNESS = {
      'rajasthan': 3, 'gujarat': 3, 'haryana': 3, 'delhi': 3, 'punjab': 3,
      'uttar pradesh': 2, 'madhya pradesh': 2, 'maharashtra': 2, 'telangana': 2,
      'andhra pradesh': 2, 'karnataka': 2, 'tamil nadu': 2, 'chhattisgarh': 2, 'bihar': 2, 'chandigarh': 2,
      'west bengal': 1, 'odisha': 1, 'jharkhand': 1, 'uttarakhand': 1, 'jammu and kashmir': 1, 'puducherry': 1,
      'dadra and nagar haveli and daman and diu': 1,
      'kerala': 0, 'goa': 0, 'himachal pradesh': 0, 'sikkim': 0, 'assam': 0, 'meghalaya': 0, 'manipur': 0,
      'mizoram': 0, 'nagaland': 0, 'tripura': 0, 'arunachal pradesh': 0, 'ladakh': 0, 'lakshadweep': 0,
      'andaman and nicobar islands': 0
    };
    function norm(s) {
      return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z ]/g, '').replace(/\s+/g, ' ').trim();
    }
    function bandFor(name) {
      var n = norm(name);
      if (n in HARDNESS) return HARDNESS[n];
      for (var k in HARDNESS) {
        if (n && (n.indexOf(k) !== -1 || k.indexOf(n) !== -1)) return HARDNESS[k];
      }
      return 1;
    }

    fetch('https://cdn.jsdelivr.net/gh/udit-001/india-maps-data@ef25ebc/geojson/india.geojson')
      .then(function (res) { return res.json(); })
      .then(function (gj) {
        var feats = gj.features || [];
        var lonMin = 999, lonMax = -999, latMin = 999, latMax = -999;
        var polys = [];
        feats.forEach(function (f) {
          var g = f.geometry;
          if (!g) return;
          var p = f.properties || {};
          var name = p.st_nm || p.ST_NM || p.NAME_1 || p.name || p.State || '';
          var rings = g.type === 'Polygon' ? [g.coordinates] : g.type === 'MultiPolygon' ? g.coordinates : [];
          rings.forEach(function (poly) {
            poly.forEach(function (ring) {
              ring.forEach(function (pt) {
                if (pt[0] < lonMin) lonMin = pt[0];
                if (pt[0] > lonMax) lonMax = pt[0];
                if (pt[1] < latMin) latMin = pt[1];
                if (pt[1] > latMax) latMax = pt[1];
              });
            });
          });
          polys.push({ name: name, band: bandFor(name), rings: rings });
        });
        var midLat = (latMin + latMax) / 2;
        var k = Math.cos(midLat * Math.PI / 180);
        var TW = 1000;
        var w = (lonMax - lonMin) * k;
        var scale = TW / w;
        var TH = Math.round((latMax - latMin) * scale);
        function px(lon) { return (((lon - lonMin) * k) * scale).toFixed(1); }
        function py(lat) { return ((latMax - lat) * scale).toFixed(1); }
        var NS = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(NS, 'svg');
        svg.setAttribute('viewBox', '0 0 1000 ' + TH);
        polys.forEach(function (p) {
          var d = '';
          p.rings.forEach(function (poly) {
            poly.forEach(function (ring) {
              d += 'M' + ring.map(function (pt) { return px(pt[0]) + ',' + py(pt[1]); }).join('L') + 'Z';
            });
          });
          var path = document.createElementNS(NS, 'path');
          path.setAttribute('d', d);
          path.setAttribute('fill', BANDS[p.band].fill);
          path.setAttribute('stroke', '#21242B');
          path.setAttribute('stroke-width', '1.1');
          path.setAttribute('stroke-linejoin', 'round');
          svg.appendChild(path);
        });
        svgWrap.appendChild(svg);
        loadingEl.hidden = true;
        svgWrap.hidden = false;
        legendEl.hidden = false;
      })
      .catch(function () {
        loadingEl.hidden = true;
        failedEl.hidden = false;
      });
  }

  /* ---------- lead modal (PORT §6 decision #1) ----------
     Tracking (ANALYTICS.md): tm_lead_open on each CTA, tm_lead_submit on the SUCCESS render —
     not on the submit click. The form is a real Shopify contact-form POST, so the page reloads;
     firing on `form.posted_successfully?` means the event counts server-confirmed leads only.
     That reload also destroys JS state, so the placement is stashed in sessionStorage at open
     time and reclaimed here — otherwise every lead would report placement "unknown". */
  function initLeadModal() {
    var modal = document.querySelector('[data-tm-lead-modal]');
    if (!modal) return;
    var track = function (n, prm, opts) { if (typeof window.tmTrack === 'function') window.tmTrack(n, prm, opts); };
    function open() {
      modal.hidden = false;
      if (window.TM && window.TM.lockScroll) window.TM.lockScroll(); // freeze the PDP behind it (Android IG / iOS)
    }
    function close() {
      modal.hidden = true;
      if (window.TM && window.TM.unlockScroll) window.TM.unlockScroll();
    }
    function sku() {
      return (window.TM_ANALYTICS && window.TM_ANALYTICS.product && window.TM_ANALYTICS.product.sku) || '';
    }
    document.querySelectorAll('[data-tm-lead-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var placement = el.getAttribute('data-tm-placement') || 'unknown';
        if (window.TM && window.TM.rememberLeadPlacement) window.TM.rememberLeadPlacement(placement);
        track('tm_lead_open', { sku: sku(), placement: placement });
        open();
      });
    });
    modal.querySelectorAll('[data-tm-lead-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    /* Stash the typed phone so the SUCCESS render (a fresh page load after the contact-form
       POST) can hash it for the Conversions API. It is written to sessionStorage — same tab,
       same origin, never sent anywhere raw — and deleted the moment it is consumed below. */
    var form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var input = modal.querySelector('#tm-lead-phone');
        try { sessionStorage.setItem('tm_lead_phone', input ? input.value : ''); } catch (e) {}
        // Bridge the pincode too, so the success render can send it to /lead (geo lookup).
        var pin = modal.querySelector('#tm-lead-pincode');
        try { sessionStorage.setItem('tm_lead_pincode', pin ? pin.value : ''); } catch (e) {}
      });
    }

    /* ---- OTP gate ----
       Only active when settings.otp_endpoint is set (window.TM_ANALYTICS.otpEndpoint). When off, the
       form behaves exactly as before — no OTP step. When on, the first submit is intercepted to send a
       code and show the verify step; on server-confirmed success we fire tm_lead_verified and RE-SUBMIT
       the SAME form natively, so the reload → .tm-lead-success → tm_lead_submit + CAPI trigger is
       untouched (LEAD-FLOW-CONTRACT.md). Unverified numbers never post → never become a Lead. */
    var otpOn = !!(window.TM_ANALYTICS && window.TM_ANALYTICS.otpEndpoint);
    var otpStep = modal.querySelector('[data-tm-lead-otp]');
    if (form && otpOn && otpStep) {
      var otpVerified = false;
      var submitBtn = form.querySelector('[type="submit"]');
      var phoneInput = modal.querySelector('#tm-lead-phone');
      var otpInput = modal.querySelector('[data-tm-lead-otp-input]');
      var otpEcho = modal.querySelector('[data-tm-lead-otp-echo]');
      var otpErr = modal.querySelector('[data-tm-lead-otp-err]');
      var otpVerifyBtn = modal.querySelector('[data-tm-lead-otp-verify]');
      var otpBackBtn = modal.querySelector('[data-tm-lead-otp-back]');
      var pincodeInput = modal.querySelector('#tm-lead-pincode');
      var formErr = modal.querySelector('[data-tm-lead-form-err]');
      var otpTimerEl = modal.querySelector('[data-tm-lead-otp-timer]');
      var otpResendBtn = modal.querySelector('[data-tm-lead-otp-resend]');
      // Step-1 heading + intro live OUTSIDE <form> (siblings of it), so form.hidden alone leaves them
      // on screen — that stacked the "Buy your machine" heading above "Verify your number". Toggle
      // them together with the form so exactly one step's heading shows. (#tm-lead-title is unique;
      // querySelector('.tm-lead-sub') returns the FIRST match = the step-1 intro, not the OTP sub.)
      var leadTitleEl = modal.querySelector('#tm-lead-title');
      var leadIntroEl = modal.querySelector('.tm-lead-sub');
      var showStepOne = function (on) {
        form.hidden = !on; otpStep.hidden = on;
        if (leadTitleEl) leadTitleEl.hidden = !on;
        if (leadIntroEl) leadIntroEl.hidden = !on;
      };
      var showErr = function (m) { if (otpErr) { otpErr.textContent = m || ''; otpErr.hidden = !m; } };
      var showFormErr = function (m) { if (formErr) { formErr.textContent = m || ''; formErr.hidden = !m; } };
      var otpSending = false;
      var resendTimer = null;

      /* 15-second cool-down, then reveal the "Resend code" button. */
      function startResendTimer() {
        var left = 15;
        if (otpResendBtn) otpResendBtn.hidden = true;
        if (otpTimerEl) { otpTimerEl.hidden = false; otpTimerEl.textContent = 'Resend code in ' + left + 's'; }
        if (resendTimer) clearInterval(resendTimer);
        resendTimer = setInterval(function () {
          left -= 1;
          if (left <= 0) {
            clearInterval(resendTimer); resendTimer = null;
            if (otpTimerEl) otpTimerEl.hidden = true;
            if (otpResendBtn) otpResendBtn.hidden = false;
          } else if (otpTimerEl) {
            otpTimerEl.textContent = 'Resend code in ' + left + 's';
          }
        }, 1000);
      }

      /* Send the code + reveal the verify step. The capture-phase gate below preventDefaults the click,
         which BYPASSES the browser's native required/pattern validation — so validate pincode + phone
         here explicitly, or junk numbers would burn an SMS. Guarded so the two entry points can't double-fire. */
      function startOtpFlow() {
        if (otpVerified || otpSending) return;
        var pincode = (pincodeInput ? pincodeInput.value : '').replace(/\D/g, '');
        var phone = (phoneInput ? phoneInput.value : '').replace(/\D/g, '');
        showFormErr('');
        if (pincode.length !== 6) { showFormErr('Enter a valid 6-digit pincode.'); return; }
        if (phone.length !== 10) { showFormErr('Enter a valid 10-digit mobile number.'); return; }
        otpSending = true;
        if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }
        var sending = (window.TM && window.TM.otpSend) ? window.TM.otpSend(phone) : Promise.resolve({ ok: true });
        sending.then(function (res) {
          otpSending = false;
          if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
          if (!res || !res.ok) {
            showFormErr(res && res.rateLimited
              ? 'Too many attempts. Please wait a minute and try again.'
              : "Couldn't send the code — check the number and try again.");
            return;
          }
          if (otpEcho) otpEcho.textContent = '+91 ' + phone;
          if (otpInput) otpInput.value = '';
          showErr('');
          showStepOne(false);
          startResendTimer();
        });
      }

      /* Shopify wraps this contact form in hCaptcha, which force-submits via form.submit() on the submit
         BUTTON click — firing NO 'submit' event, so a submit-event listener alone is silently bypassed
         (found live 2026-07-24). Intercept the click in CAPTURE on the FORM (an ancestor) so we run
         BEFORE hCaptcha's own button handler regardless of registration order, and stop the whole chain
         until OTP is verified. On the post-verify re-click, otpVerified lets it through to the real
         (captcha) submit — restoring the exact original flow, incl. the .tm-lead-success → tm_lead_submit
         + CAPI trigger. */
      form.addEventListener('click', function (e) {
        if (otpVerified) return;
        var btn = e.target && e.target.closest ? e.target.closest('[type="submit"], button:not([type])') : null;
        if (!btn || !form.contains(btn)) return;
        e.preventDefault(); e.stopImmediatePropagation();
        startOtpFlow();
      }, true);
      /* Keyboard submit (Enter in a field) fires no button click — cover that path too. */
      form.addEventListener('submit', function (e) {
        if (otpVerified) return;
        e.preventDefault();
        startOtpFlow();
      });

      if (otpVerifyBtn) otpVerifyBtn.addEventListener('click', function () {
        if (otpVerifyBtn.disabled) return;
        var phone = phoneInput ? phoneInput.value : '';
        var code = otpInput ? otpInput.value : '';
        otpVerifyBtn.disabled = true; otpVerifyBtn.classList.add('is-loading'); showErr('');
        var checking = (window.TM && window.TM.otpVerify) ? window.TM.otpVerify(phone, code) : Promise.resolve(true);
        checking.then(function (verified) {
          otpVerifyBtn.disabled = false; otpVerifyBtn.classList.remove('is-loading');
          if (!verified) { showErr("That code isn't right. Check it and try again."); return; }
          otpVerified = true;
          track('tm_lead_verified', { sku: sku() });  // NEW event — own Meta custom event, NOT a Lead
          if (submitBtn) submitBtn.click();            // re-submit → native POST → reload → tm_lead_submit + CAPI
        });
      });

      if (otpResendBtn) otpResendBtn.addEventListener('click', function () {
        if (otpResendBtn.hidden) return;
        var phone = (phoneInput ? phoneInput.value : '').replace(/\D/g, '');
        otpResendBtn.hidden = true; showErr('');
        var sending = (window.TM && window.TM.otpSend) ? window.TM.otpSend(phone) : Promise.resolve({ ok: true });
        sending.then(function (res) {
          if (!res || !res.ok) {
            showErr(res && res.rateLimited ? 'Too many attempts. Please wait a minute.' : "Couldn't resend the code — try again.");
            otpResendBtn.hidden = false; return;
          }
          startResendTimer();
        });
      });

      if (otpBackBtn) otpBackBtn.addEventListener('click', function () {
        if (resendTimer) { clearInterval(resendTimer); resendTimer = null; }
        showStepOne(true); showErr('');
      });
    }

    if (modal.querySelector('.tm-lead-success')) {
      open(); // show confirmation after form post
      /* Collapse the form to just the confirmation — the pincode/phone fields, the submit button and
         the "leave your pincode" sub are noise once the lead is in. */
      var leadSub = modal.querySelector('.tm-lead-sub');
      if (leadSub) leadSub.hidden = true;
      var successForm = modal.querySelector('#tm-lead-form');
      if (successForm) {
        successForm.querySelectorAll('.tm-lead-field').forEach(function (el) { el.hidden = true; });
        var successSubmit = successForm.querySelector('[type="submit"]');
        if (successSubmit) successSubmit.hidden = true;
      }
      var placement = window.TM && window.TM.takeLeadPlacement ? window.TM.takeLeadPlacement() : 'unknown';

      var phone = '';
      try {
        phone = sessionStorage.getItem('tm_lead_phone') || '';
        sessionStorage.removeItem('tm_lead_phone'); // consume immediately — don't leave PII around
      } catch (e) {}

      var pincode = '';
      try {
        pincode = sessionStorage.getItem('tm_lead_pincode') || '';
        sessionStorage.removeItem('tm_lead_pincode');
      } catch (e) {}

      /* Personalise the success line with the pincode the user just entered. The Liquid renders a
         static "your area" fallback (no-JS / lost sessionStorage); when we have the pincode, swap in
         the specific version. Text-only — never touch the .tm-lead-success class (the conversion
         trigger, see LEAD-FLOW-CONTRACT.md). */
      var successEl = modal.querySelector('.tm-lead-success');
      if (successEl && pincode) {
        successEl.textContent = "You're on the priority list for " + pincode + ". We're rolling out area by area — our team will call within 48 hours to confirm your order and delivery.";
      }

      /* Server leg first so it can mint the event_id, then the browser leg reuses that SAME id.
         Matching ids are what stop Meta counting this conversion twice. */
      var eventId = window.TM && window.TM.sendLeadCapi
        ? window.TM.sendLeadCapi({ phone: phone, placement: placement })
        : null;

      track('tm_lead_submit', { sku: sku(), placement: placement }, eventId ? { eventID: eventId } : undefined);

      /* Structured lead capture → D1 (tm-leads dashboard). Parallel to CAPI, reuses the SAME
         event_id so the DB row and the Meta Lead stay one conversion. Fire-and-forget: never
         block the form. /lead is origin-gated to truemachines.co, same as /capi. */
      if (eventId) {
        var attr = (window.TM && window.TM.readUtm) ? window.TM.readUtm() : {}; // utm_* + landing_path, or {} if none
        try {
          fetch('https://capi.truemachines.co/lead', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            keepalive: true,
            body: JSON.stringify(Object.assign({
              phone: phone,          // raw number the user typed (same value CAPI hashes)
              pincode: pincode,
              event_id: eventId,     // SAME id as the Meta Lead
              source: 'washer-pdp',
              ts: new Date().toISOString()
            }, attr))                // creative attribution: utm_source/medium/campaign/content/term + landing_path
          });
        } catch (e) { /* never block the form */ }
      }
    }
  }

  /* ---------- spec-sheet mobile peek (r2) ----------
     Instant class toggle (no height transition, Decision 7). The toggle is CSS-hidden >640, so this
     only ever fires on phones. tm_spec_expand fires BOTH directions on real state change (Decision 8). */
  function initSpecPeek() {
    var frame = document.querySelector('.tm-spec-frame');
    if (!frame) return;
    var toggle = frame.querySelector('[data-tm-spec-toggle]');
    if (!toggle) return;
    function setExpanded(exp) {
      if (frame.classList.contains('is-expanded') === exp) return; // real state change only
      frame.classList.toggle('is-expanded', exp);
      toggle.setAttribute('aria-expanded', exp ? 'true' : 'false');
      if (typeof window.tmTrack === 'function') {
        window.tmTrack('tm_spec_expand', {
          sku: (window.TM_ANALYTICS && window.TM_ANALYTICS.product && window.TM_ANALYTICS.product.sku) || '',
          direction: exp ? 'expand' : 'collapse'
        });
      }
    }
    function toggleFn() { setExpanded(!frame.classList.contains('is-expanded')); }
    toggle.addEventListener('click', toggleFn);
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleFn(); }
    });
  }

  function init() {
    initHero();
    initChecklist();
    initWaterMap();
    initSpecPeek();
    initLeadModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
